import React, { useContext } from 'react';
import { BudgetExpenseOrIncome } from 'business/constants';
import {
    getImputationDimensionsLabels,
    EXCLUDED_DIMENSIONS_BY_CONTEXT,
} from 'routes/BudgetModule/config/hooks';
import { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';
import {
    BudgetProposalT,
    InscriptionWithMetadata,
} from 'routes/BudgetModule/config/types';
import { isCustomBudgetProposal } from 'routes/BudgetModule/components/BudgetProposal/Resource/hooks/budgetProposal';
import MoveInscriptionModal from './MoveInscriptionModal';
import { InscriptionQueryKey } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';
import { IntegrationContext } from 'routes/BudgetModule/components/BudgetWithProvider/IntegrationContext';
import { ImputationDimensionsContext } from 'routes/BudgetModule/components/BudgetWithProvider/ImputationDimensionsContext';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    selectedInscription: InscriptionT;
    queryCacheKey: InscriptionQueryKey;
    inscriptionIdColumn: keyof InscriptionT;
    inscriptions: InscriptionWithMetadata[];
    budgetProposal: BudgetProposalT;
    budgetProposals: BudgetProposalT[];
    expenseOrIncome: BudgetExpenseOrIncome;
};

/*
 * Move Inscription is the component where all the necessary data is queried in order to
 * display the MoveInscriptionModal.
 */
function MoveInscription({
    isOpen,
    onClose,
    selectedInscription,
    inscriptionIdColumn,
    queryCacheKey,
    budgetProposal,
    budgetProposals,
    expenseOrIncome,
}: Props): React.ReactElement {
    // SCHOOL --
    const integrations = useContext(IntegrationContext);
    const isSchool = isCustomBudgetProposal(integrations);

    const imputationRawDimensions = useContext(ImputationDimensionsContext);

    const imputationDimensions = getImputationDimensionsLabels(
        imputationRawDimensions,
        [
            ...EXCLUDED_DIMENSIONS_BY_CONTEXT.BudgetProposal,
            ...EXCLUDED_DIMENSIONS_BY_CONTEXT.ExpenseIncome,
            ...EXCLUDED_DIMENSIONS_BY_CONTEXT.SuperOperation,
        ],
        isSchool,
    );

    return (
        <MoveInscriptionModal
            isOpen={isOpen}
            onClose={onClose}
            budgetProposal={budgetProposal}
            budgetProposals={budgetProposals}
            inscriptionIdColumn={inscriptionIdColumn}
            queryCacheKey={queryCacheKey}
            selectedInscription={selectedInscription}
            imputationDimensions={imputationDimensions}
            expenseOrIncome={expenseOrIncome}
        />
    );
}

export default MoveInscription;
